<template>
  <section id="cart" class="max-w-1600 wp_AllPageMarginTop">
			<page-loader v-if="showOrderSuccessLoader">
			</page-loader>
    <div v-else>
      <section class="content checkout-content max-w-1800 pt-0">
        <div class="order-success-wrapper pb-4">
          <div class="top-head p-3">
            <h5 style="color: green" data-test="orderSuccessHead"
																id="orderSuccessHead">
              <i class="far fa-check-circle" data-test="orderSuccessIcon"
																	id="orderSuccessIcon"></i>
              <b data-test="orderSuccessHeadBold"
																	id="orderSuccessHeadBold">Order Successful!</b>
            </h5>
            <hr />
            <div class="order-success-top-container">
              <div class="left">
                <h6 data-test="orderSuccessOrderNoHead"
																				id="orderSuccessOrderNoHead">Order Id: {{getOrderData.order_number}}</h6>
                <h6
                  data-test="orderSuccessOrderDateHead"
                  id="orderSuccessOrderDateHead"
                >Order Date: {{dateFormattingSuccess(new Date())}}</h6>
                <h6
                  v-if="getBuyNowProduct && getBuyNowProduct.length > 0"
                  data-test="orderSuccessShippingHead1"
                  id="orderSuccessShippingHead1"
                >Shipping Charges: {{this.getShippingCharge * getBuyNowProductCount | currencyConversion}}</h6>
                <h6
                  v-else
                  data-test="orderSuccessShippingHead2"
                  id="orderSuccessShippingHead2"
                >Shipping Charges: {{this.getShippingCharge * getCartTotalQuantity | currencyConversion}}</h6>
                <h6
                  v-if="getBuyNowProduct && getBuyNowProduct.length > 0"
                  data-test="orderSuccessTaxHead1"
                  id="orderSuccessTaxHead1"
                >Tax Charges: {{this.getTaxCharge * getBuyNowProductCount | currencyConversion}}</h6>
                <h6
                  v-else
                  data-test="orderSuccessTaxHead2"
                  id="orderSuccessTaxHead2"
                >Tax Charges: {{this.getTaxCharge * getCartTotalQuantity | currencyConversion}}</h6>
                <h6
                  data-test="orderSuccessTotalAmtHead"
                  id="orderSuccessTotalAmtHead"
                >Total Amount: {{getOrderData.total_amount_to_pay | currencyConversion}}</h6>
              </div>
              <div class="middle">
                <p
                  v-if="getSelectedAddress && getSelectedAddress.firstName && getSelectedAddress.lastName"
                  data-test="orderSuccessName"
                  id="orderSuccessName"
                >{{getSelectedAddress.firstName+' '+getSelectedAddress.lastName}}</p>
                <p
                  v-if="getSelectedAddress && getSelectedAddress.addressLine1 &&
                    getSelectedAddress.place &&
                    getSelectedAddress.country"
                  data-test="orderSuccessAddress"
                  id="orderSuccessAddress"
                >
                  {{getSelectedAddress.addressLine1+' '+
                  getSelectedAddress.place+ ' '+
                  getSelectedAddress.country}}
                </p>
                <p
                  v-if="getSelectedAddress && getSelectedAddress.phoneNo"
                  data-test="orderSuccessPhnNo."
                  id="orderSuccessPhnNo."
                >Phone: {{getSelectedAddress.phoneNo}}</p>
              </div>
              <div class="right">
                <button
                  class="btn gotomyorder"
                  @click.prevent="$router.push('/user/orders')"
                  data-test="orderSuccessGoToOrderBtn"
                  id="orderSuccessGoToOrderBtn"
                >Go to My Order</button>
              </div>
            </div>
          </div>
          <div class="orderdetails-wrapper">
            <cart-container
              :productsData="getBuyNowProduct"
              :productCount="getBuyNowProductCount"
              :totalPrice="getBuyNowTotal"
              :totalCartPrice="getBuyNowItemTotal"
              :totalOffer="getBuyNowOffer"
              :disabled="true"
              v-if="getBuyNowProductCount > 0"
            ></cart-container>
            <cart-container
              :productsData="getCartProducts"
              :productCount="getCartCount"
              :totalPrice="getcartTotal"
              :totalCartPrice="getcartItemTotal"
              :totalOffer="getcartTotalOffer"
              :disabled="true"
              v-else
            ></cart-container>
          </div>
          <button
            type="button"
            class="btn add-to-cart my-3 mx-auto order-page-continue"
            id="cart-summary-continue-btn"
            @click.prevent="$router.push('/')"
            data-test="orderSuccessContinueBtn"
          >Continue Shopping</button>
        </div>
        <!-- <div class="row">
          <cart-list :cartProducts="getBuyNowProduct"
                     :removeButton="false"
                     v-if="getBuyNowProduct.length > 0"
          >
          </cart-list>
          <cart-list :cartProducts="getOrderProducts"
                     :removeButton="false"
                     v-else
          >
          </cart-list>
          <cart-summary-container :continueShopping="true">
          </cart-summary-container>
        </div>-->
      </section>
    </div>
  </section>
</template>

<script>
import CartContainer from '@/components/pages/cart/cartContainer/CartContainer'
// import CartSummaryContainer from '@/components/widgets/cart/CartSummaryContainer';
// import CartList from '@/components/widgets/cart/CartList';
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import { cartApis } from '@/services/ApiServices/cartApis'
import { store } from '../../../store/store'
import { customerApi } from '../../../services/ApiServices/customerApi'
import PageLoader from '../../shared/loader/pageLoader'

export default {
	components: {
		PageLoader,
		CartContainer
		// CartSummaryContainer,
		// CartList,
	},
	data () {
		return {
			user: Object,
			buyNow: {
				type: Boolean,
				default: false
			},
			showOrderSuccessLoader: true
		}
	},
	beforeMount () {
		this.checkData()
		if (!this.buyNow) {
			cartApis.clearCart()
		}
		customerApi.getCustomerDetails().then((res) => {
			this.showOrderSuccessLoader = false
		})
	},
	mounted () {
		this.user = this.getUserData
		this.isBuyNow()

		this.clearGiftAmountData()
		this.clearGiftCardNo()
		this.clearGiftCardPin()
		this.clearCoinRedeemData()
		store.dispatch('user/setPromoCodeData', '')
	},
	beforeDestroy () {
		this.deleteSelectedAddressData()
		this.clearOrderData()
		if (!this.buyNow) {
			this.emptyCart()
		}
		this.deleteFromBuyNow()
	},
	computed: {
		...mapGetters('user', [
			'isAuthenticated',
			'getUserCartData',
			'getOrderIdData',
			'getUserData',
			'getSelectedAddress',
			'getOrderData'
		]),
		...mapGetters('cart', [
			'getCartProducts',
			'getCartCount',
			'getcartTotal',
			'getcartItemTotal',
			'getcartTotalOffer',
			'getCartTotalQuantity'
		]),
		...mapGetters('buynow', [
			'getBuyNowProduct',
			'getBuyNowProductCount',
			'getBuyNowTotal',
			'getBuyNowItemTotal',
			'getBuyNowOffer'
		]),
		...mapGetters('order', ['getOrderProducts']),
		...mapGetters('charges', ['getShippingCharge', 'getTaxCharge'])
	},
	methods: {
		...mapActions('user', [
			'deleteSelectedAddressData',
			'setUserData',
			'clearOrderData',
			'clearGiftAmountData',
			'clearGiftCardNo',
			'clearGiftCardPin',
			'clearCoinRedeemData'
		]),
		...mapActions('cart', ['setConfirmedProducts', 'emptyCart']),
		...mapActions('buynow', ['deleteFromBuyNow']),
		isBuyNow () {
			if (this.getBuyNowProduct.length > 0) {
				this.buyNow = true
			}
		},
		continueShoping () {
			this.$router.push('/')
		},
		checkData () {
			if (!this.isAuthenticated || !this.getOrderData.order_number) {
				this.$router.push('/')
			} else {
				this.showOrderSuccessLoader = false
				this.$toasted.show('Order success,Thank you for purchasing! ')
			}
		},
		dateFormattingSuccess (d) {
			const a = moment(d).format('MMM Do YYYY')
			return a
		}
	},
	beforeRouteLeave (to, from, next) {
		this.setConfirmedProducts([])
		if (this.buyNow === true) {
			this.deleteFromBuyNow()
			//
		} else {
			cartApis.clearCart()
			this.emptyCart()
		}
		next()
	}
}
</script>
